import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { AccountMenuComponent } from './account-menu';

@NgModule({
  declarations: [
    AccountMenuComponent,
  ],
  entryComponents: [
    AccountMenuComponent
  ],
  imports: [
    IonicModule,
  ],
  exports: [
    AccountMenuComponent
  ]
})
export class AccountMenuComponentModule { }



// WEBPACK FOOTER //
// ./src/components/dev-header/account-menu/account-menu.module.ts